<template>
  <v-flex xs6 mt-5 px-1>
    <v-layout row wrap ma-0>
      <v-flex xs12>
        <p class="font-weight-medium text-center mb-0" style="font-size:10px;">
          {{ dataSource.title }}
        </p>
        <p class="font-weight-medium text-center mb-0" style="font-size:10px;">
          {{ dataSource.title2 }}
        </p>
        <v-divider class="my-1"></v-divider>
      </v-flex>
      <v-flex xs12 class="d-flex justify-space-around">
        <div v-for="(item, index) in dataSource.data" :key="`year-${index}`">
          <p class="font-weight-regular text-center mb-0" style="font-size:10px;">
            ปี {{ item.year }}
          </p>
          <p class="body-2 font-weight-medium bloody--text text-center mb-0">
            {{ utils.formatNumber(item.amount) }}
          </p>
        </div>
      </v-flex>
      <v-flex xs12 class="light2-bg d-flex align-center flex-row-reverse">
        <v-icon v-if="isEqualAccident(dataSource.data)" color="mastard">{{
          compareIcon(dataSource.data)
        }}</v-icon>
        <div v-else class="font-weight-bold caption mx-2 mastard--text">-</div>
        <div class="caption mastard--text">{{ utils.formatNumber(dataSource.percentage) }}</div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: 'StatisticsYearSection',
  components: {},
  props: {
    dataSource: {
      type: Object,
      defaultL() {
        return {
          title: '',
          title2: '',
          data: [],
          percentage: 0
        };
      }
    }
  },
  data: () => ({}),
  mounted() {},
  methods: {
    isEqualAccident(val) {
      return val && val.length && val[0].amount != val[1].amount;
    },
    compareIcon(val) {
      if (val[0].amount > val[1].amount) {
        return 'arrow_drop_down';
      }
      return 'arrow_drop_up';
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.light2-bg {
  background-color: #ededed;
  border-radius: 3px;
  height: 24px;
}
</style>
